module.exports = __webpack_public_path__ + "img/back01_sp.13162b29.jpg";